/**
 * @file feedbackSlice.js
 * @description Redux slice for managing feedback data and route paths.
 * This file contains the actions and reducers related to feedback, including setting
 * the list of feedback and the feedback route path. It also handles resetting the state.
 * 
 * @author Your Name
 * @date 2025-05-15
 */

import { createSlice } from '@reduxjs/toolkit';

// Initial state for the feedback slice
const initialState = {
    feedbackList: null,    // Holds the list of feedback
    feedBackRoute: '/',    // Default route path for feedback
};

// Creating the feedback slice using Redux Toolkit
const feedbackSlice = createSlice({
    name: 'feedback',      // Name of the slice in Redux store
    initialState,          // Initial state for the slice
    reducers: {
        /**
         * Set the feedback list.
         * @param {Object} state - The current state.
         * @param {Object} action - The action containing the new feedback list.
         */
        setFeedbackList: (state, action) => {
            state.feedbackList = action.payload; // Update feedback list in the state
        }
    },

    /**
     * Extra reducers can be used to handle external actions (e.g., resetting the state).
     * Here, we are listening for a reset state action to reset the state back to its initial values.
     */
    extraReducers: (builder) => {
        builder.addCase('RESET_STATE', () => initialState); // Reset state when the 'RESET_STATE' action is dispatched
    }
});

// Exporting the actions generated by createSlice for use in dispatching
export const { setFeedbackList } = feedbackSlice.actions;

// Exporting the reducer to be used in the store configuration
export default feedbackSlice.reducer;
